import MenuItem from './MenuItem';
import { makeStyles } from '@material-ui/styles';
import { Text, PinLine, UnpinLine } from '@bizzabo/design-system';

const PinMessage = ({ onPinClicked, isPinned }) => {
    const classes = useStyles();
    const pinUnpin = isPinned ? 'Unpin' : 'Pin';

    return (
        <MenuItem onClick={onPinClicked}>
            <div className={classes.icon}>{isPinned ? <UnpinLine /> : <PinLine />}</div>
            <Text variant="t81">{`${pinUnpin} message`}</Text>
        </MenuItem>
    );
};
const useStyles = makeStyles(
    () => ({
        icon: { marginRight: 10, marginTop: 2 },
    }),
    {
        classNamePrefix: PinMessage.name,
    }
);
export default PinMessage;
